export const translations = {
  'validation.empty_key_name': 'Key name cannot be empty',
  'validation.max_characters': 'Max 50 characters allowed',
};
